import { Base } from '@studiometa/js-toolkit';

/**
 * Button return class.
 */
export default class ReturnBtn extends Base {
  /**
   * Class cfnig
   * @type {object}
   */
  static config = {
    name: 'ReturnBtn',
    refs: ['btn'],
  };

  /**
   * On mounted
   */
  mounted() {
    this.backlink = this.$el.dataset.backlink;
  }

  /**
   * On btn click
   * @returns {void}
   */
  onBtnClick() {
    if (document.referrer !== '') {
      window.history.back();
    } else {
      window.location.href = this.backlink;
    }
  }
}
